import styled from 'styled-components'

const Box = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${props => props.theme.color.monochrome.lighter};
  padding: 5px;
  height: 127px;
  width: 140px;
  line-height: 1;
  text-align: center;

  @media only screen and (min-width: ${props => props.theme.size.breakpoint['min-width'].sm}) {
    width: 180px;
    padding: 25px;
  }

  h2 {
    margin-bottom: 0;
  }

  p {
    color: ${props => props.theme.color.monochrome.dark};
    width: 100%;
  }

  div {
    display: block;
  }

  > .rating {
    align-self: center;
  }
`

export { Box } // eslint-disable-line
